export const SAMPLES = 'SAMPLES';
export const SEQUENCE = 'SEQUENCE';
export const MIX = 'MIX';
export const LIST = 'LIST';
